/*
  Where easySBC lives off-site. One home for the handles: the Twitter → X move
  otherwise meant hunting the same literal through the footer, the drawer, the
  who-are-we page, the contact page and both error boundaries.
*/
export const DISCORD_URL = "https://discord.gg/mmNtdnUcJf";
export const X_URL = "https://x.com/easysbc";
export const INSTAGRAM_URL = "https://www.instagram.com/easysbc/";
export const TIKTOK_URL = "https://www.tiktok.com/@easysbc";
